import type { CSSProperties } from 'react';

import {
  resolveSpartanParallaxScrollSpeed,
  type SpartanParallaxScrollSpeed,
} from '@/app/lcv/components/sections/spartan/products/shared/product-parallax-scroll';

interface SpartanProductHeroParallaxStyle extends CSSProperties {
  '--spartan-parallax-mobile-start-y'?: string;
  '--spartan-parallax-mobile-end-y'?: string;
  '--spartan-parallax-desktop-start-y'?: string;
  '--spartan-parallax-desktop-end-y'?: string;
}

const getOffset = (scrollSpeed: string, direction: 1 | -1) => {
  const speed = Number.parseFloat(scrollSpeed);
  if (!Number.isFinite(speed) || speed === 0) return '0px';

  return `calc(var(--spartan-hero-vh-unit, 1svh) * ${speed * direction * 100})`;
};

export const getSpartanProductHeroParallaxStyle = (
  scrollSpeed: SpartanParallaxScrollSpeed | undefined
): SpartanProductHeroParallaxStyle | undefined => {
  if (!scrollSpeed) return undefined;

  const mobileSpeed = resolveSpartanParallaxScrollSpeed(scrollSpeed, 'mobile');
  const desktopSpeed = resolveSpartanParallaxScrollSpeed(
    scrollSpeed,
    'desktop'
  );
  if (!mobileSpeed || !desktopSpeed) return undefined;

  return {
    '--spartan-parallax-mobile-start-y': getOffset(mobileSpeed, 1),
    '--spartan-parallax-mobile-end-y': getOffset(mobileSpeed, -1),
    '--spartan-parallax-desktop-start-y': getOffset(desktopSpeed, 1),
    '--spartan-parallax-desktop-end-y': getOffset(desktopSpeed, -1),
  };
};
